module.exports = __webpack_public_path__ + "static/img/logo30.3d627b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo30.png
// module id = KrRu
// module chunks = 1